export enum Gateway {
  'SEGMENTS' = 'SEGMENTS',
  'CONTEXTUAL_RECORDING' = 'CONTEXTUAL_RECORDING',
  'HELP_CENTER' = 'HELP_CENTER',
  'SALESFLOOR' = 'SALESFLOOR',
  'AI_CHAT' = 'AI_CHAT',
  'THREED_AVATAR' = 'THREED_AVATAR',
}
